YP.TypeTicketStyleManager = function() {
    var pictureForm = $('form.pic-ticket #fileupload');
    var ticketItem = $('#select_ticket li a');
    return {
        init: function() {
            if (pictureForm.length > 0) {
                YP.TypeTicketStyleManager().initTicketStyleForm();
                ticketItem.live('click', this.changeTicket);
            }
        },
        changeTicket: function(e) {
            e.preventDefault();
            var link = $(this);
            var elements = $('#select_ticket_list li');
            $("#preview-ticket").attr("disabled", "disabled");
            $('#tickets-wrap').css('opacity', 0.5);
            elements.removeClass('actif');
            link.parent().attr('class', 'actif');
            $.ajax({
                type: 'GET',
                url: $(this).attr('href'),
                success: function(data) {
                    $('.content-ajax').html(data);
                    YP.TypeTicketStyleManager().initTicketStyleForm();
                    $('#tickets-wrap').css('opacity', 1);
                    $("#preview-ticket").attr("disabled", false).attr("data-type-ticket-id", link.data('type-ticket-id'));

                },
                error: function(data) {}
            });
        },
        initPictureForm: function() {
            $('form.pic-ticket #fileupload').fileupload({
                dataType: 'json',
                url: $('form.pic-ticket').data('url'),
                send: function(e, data) {
                    $('.refresh', 'form.pic-ticket').show();
                },
                add: function(e, data) {
                    data.submit();
                },
                done: function(e, data) {
                    $('.refresh', 'form.pic-ticket').hide();
                    if (data.result) {
                        $('form.pic-ticket #picture_name').val(data.result.name);

                        $('.content__ticket_info img').attr("src", '/uploads/original/' + data.result.name).css({"width": "100%"});
                    }
                }
            });
        },
        initTicketStyleForm: function() {
            YP.TypeTicketStyleManager().initPictureForm();
            $("form.pic-ticket input.color-picker").minicolors({
                change: function(hex, rgb) {
                    $('.content__ticket_info, .content__ticket_info p strong').css('color', hex);
                }
            });

            $('#tickets-wrap').hover(function() {
                $('.delete-visuel').show();
            }, function() {
                $('.delete-visuel').hide();
            });
        },
        rgb2hex: function(rgb) {
            rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            function hex(x) {
                return ("0" + parseInt(x).toString(16)).slice(-2);
            }
            return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
        }
    }
};

window.addEventListener("load", function() {
    YP.TypeTicketStyleManager().init();
});
